import { formatAmount } from "../../../utils";
import { TextField } from "../../form";
import { GraphQLTableColumn } from "../../GraphQL";

export function FinancialColumnTemplate<T extends object = {}>(params?: GraphQLTableColumn<T>): GraphQLTableColumn<T> {
  return {
    Header: "",
    Filter: <TextField
      placeholder="Find..."
      disabled
    />,
    Cell: ({ value, bodyCellProps }: any) => {
      const prettified = formatAmount(value);
      return (
        <span
          title={prettified}
          {...bodyCellProps}
          style={{ textAlign: "right", ...bodyCellProps?.style }}
        >
          {prettified}
        </span>
      );
    },
    Footer: ({ footerValue: value }: any) => value === undefined
      ? null
      : <div style={{ textAlign: "right" }} title={formatAmount(value)}>{formatAmount(value)}</div>,
    ...params,
    excelProps: {
      numFmt: "$#,##0.00;[Red]-$#,##0.00",
      totalsRowFunction: "sum",
      filterButton: true,
      ...params?.excelProps,
    },
  };
}

export default FinancialColumnTemplate;
